import { ApiCompleteMessageItem, ApiMessageProperty } from '@agunity/api-v4';
import { apiService } from '../../api/apiService';

export const getMessages = () => async () => {
  const response = await apiService.messageV11ListList();
  return response;
};

export const sendMessages = (data: ApiCompleteMessageItem) => async () => {
  const response = await apiService.messageV10ItemCreate(data);
  return response;
};

export const updateOrgStatus = (messageId: number) => async () => {
  const body: ApiMessageProperty[] = [
    {
      id: messageId,
      isRead: true
    }
  ];
  const response = await apiService.messageV10ItemsPropertyPartialUpdate(body);
  return response;
};
